import seedrandom from "seedrandom"
const AssessmentForUser =
  require("assessments/models/assessment-for-user").default

export default Pathwright.module(
  "AssessmentShow",
  function (AssessmentShowModule, App, Backbone, Marionette, $, _) {
    this.startWithParent = false

    // TODO: cache for user?
    const assessmentsCache = {}
    Pathwright.reqres.setHandler(
      "get:assessment:for:user",
      function (assessmentID, userID, forceReload) {
        if (forceReload == null) {
          forceReload = false
        }
        const key = `${assessmentID}:${userID}`
        if (!assessmentsCache[key] || forceReload) {
          assessmentsCache[key] = new AssessmentForUser({
            assessmentID,
            userID
          })
        }
        return assessmentsCache[key]
      }
    )

    Pathwright.reqres.setHandler("get:assessment:context", function () {
      let step
      let assessmentContext = {}

      if ((window.context != null ? window.context.step : undefined) == null) {
        step = window.App.stores.requestStore("step").get("step")
      } else {
        // Legacy UI
        ;({ step } = window.context)
      }

      if (step != null) {
        assessmentContext = {
          stepID: step.id,
          sid: step.id,
          userID: window.App.request("get:user").id
        }
      }

      return assessmentContext
    })

    return Pathwright.commands.setHandler(
      "seed:for:user",
      function (assessmentID, userID) {
        // Seeds the Math.random() function to be consistent for the
        // given user within the given assessment
        // TODO: factor in retake attempts?
        if (userID == null) {
          userID = null
        }
        if (!userID) {
          userID = window.App.request("get:user").id
        }
        const seed = `${userID}:${assessmentID}`
        return seedrandom(seed)
      }
    )
  }
)
